import { IssueApi, issuesApi } from "api/issuesApi";
import { useEffect, useState } from "react";

export const useIssue = (issueId: number | string | undefined) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<IssueApi | null>(null);

  const fetchResource = async () => {
    if (!issueId) {
      setLoading(false);
      return;
    }
    const res = await issuesApi.fetchById(Number(issueId));
    try {
      setData(res.data);
    } catch (error) {
      // Handle error appropriately, perhaps with another state variable
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchResource();
  }, [issueId]);

  return { loading, data, refresh: fetchResource };
};
